//import Libraries
import React, {Component} from 'react'
import {connect} from 'react-redux';
import {Button, Table} from 'reactstrap';

//import Components

//import Actions
import * as cartActions from '../actions/cartActions';

//import Styles

const marginStyle = {
    margin : '10px 10px'
}

class CartItem extends Component {

    constructor(props) {
        super(props);

        this.state = {
            quantity : props.quantity
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot){
        if(prevProps.quantity !== this.props.quantity) {
            this.setState({
                quantity : this.props.quantity
            })
        }
    }

    handleOnChange = (e) => {
        const isMinus = parseInt(e.target.value) <= 0;
        const isEmpty = e.target.value === '';

        let newValue = parseInt(e.target.value);
        if(isMinus || isEmpty) {
            newValue = 1; 
        }
        this.setState({
            [e.target.name] : newValue
        })

        this.props.onUpdateCartQuantity(this.props.index, newValue); 
    }

    onBlur = (e) => {
        const isMinus = parseInt(e.target.value) <= 0;
        const isEmpty = e.target.value === '';

        let newValue = parseInt(e.target.value);
        if(isMinus || isEmpty) {
            newValue = 1; 
        }
        this.setState({
            [e.target.name] : newValue
        })
            this.props.onUpdateCartQuantity(this.props.index, newValue); 
    } 


    render() {
        const { id, name, type, typeIndex} = this.props;

        return (
            <tr className="cartRow">
                <td>{name[this.props.universal.language]}</td>
                <td>{type}</td>
                <td>
                    <input 
                        type="number" 
                        name="quantity" 
                        value={this.state.quantity} 
                        onChange={this.handleOnChange} 
                        // onBlur={this.onBlur}
                        min="1"
                    />
                </td>
                <td>
                    <Button
                        color="danger" outline size="sm"
                        onClick={
                            () => this.props.onRemoveFromCart(id, typeIndex)}
                        >
                            삭제
                    </Button>
                </td>
            </tr>
        )
    }

}

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        onRemoveFromCart : (id, typeIndex) => {
            dispatch(cartActions.removeFromCart(id, typeIndex))
        },
        onUpdateCartQuantity : (index, quantity) => {
            dispatch(cartActions.updateCartQuantity({ index, quantity }))
        }
    }
}

export default connect(null, mapDispatchToProps)(CartItem);



// WEBPACK FOOTER //
// ./src/pages/Store/Cart/CartItem.js